import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import { formatName } from '../../common/common';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

export const Comment = (props) => {
    console.log(props);
    let exp = 'panel5';
    if (props.Expense === true) {
      exp = false;
    }
    const [expanded, setExpanded] = React.useState(exp);
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel5bh-content"
                id="panel5bh-header"
            >
                {props.Expense === true ?
                    <Typography variant="subtitle1" gutterBottom>Notes</Typography>
                    : <Typography variant="subtitle1" gutterBottom>Comments</Typography>
                }
            </AccordionSummary>
            <AccordionDetails>
                {props.Comments.length > 0 ?
                    <ul className="list-standard list-ul-shrink">
                        {(props.Comments).map((item) =>
                            <>
                                <li className="list-item">
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ flex: 1 }}>
                                            <div>
                                                <Typography variant="body1" gutterBottom>{item.comment}</Typography>
                                            </div>
                                            <div>
                                                <Typography variant="body2" display="block">
                                                    <i>
                                                        Posted by {formatName(item.cby_first_name, null, item.cby_last_name)} On {item.created_on}
                                                    </i>
                                                </Typography>
                                                {item.entity_type === 'timeoff' && item.modified_on && (
                                                    <Typography variant="body2" display="block" sx={{ marginTop: '4px' }}>
                                                        <i>Modified On {item.modified_on}</i>
                                                    </Typography>
                                                )}
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', columnGap: '0.5rem' }}>
                                            {(item.entity_type == 'timeoff' && props.HrPermission && (props.LoggedUser == item.created_by)) &&
                                                <>
                                                    <IconButton onClick={() => props.CommentbtnClick('edit', item.id)}>
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                    <IconButton onClick={() => props.OnDelete('delete', item.id)}>
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </>
                                            }
                                        </div>
                                    </div>
                                </li>
                                <hr/>
                            </>
                        )}
                    </ul>
                    :
                    props.Expense === true ?
                        <Typography variant="body2" gutterBottom align='center'>No notes for this expense</Typography>
                        : <Typography variant="body2" gutterBottom align='center'>No comments for this request</Typography>
                }
            </AccordionDetails>
        </Accordion>
    );
}
